<template>
	<BookingModuleMain />
</template>

<script>
import BookingModuleMain from "./BookingModuleMain.vue";
export default {
	components: {
		BookingModuleMain
	}
};
</script>